import axios from "axios";
import { alert, confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import { getApiErrorMessage, CONCURRENCY_HANDLED } from "../../../../common/concurrency";
import { MESSAGES } from "../../../../common/Messages";
import data from "../../../../assets/apiRoutes.json";

/**
 * Confirm-then-delete for one WM Transaction Management Data Profile, shared by the listing and the
 * form. Resolves true once the row is gone and the green toast is up (rule 7), false when the user
 * cancels or the delete fails — a failure has already been reported by then, and a 409 has already had
 * its dialog from the AppContainer axios interceptor.
 *
 * `setBusy`, when given, is called with true while the request is in flight and false after it.
 */
export function deleteTransManagementProfile(rowId, accessToken, setBusy) {
    // Rule 12: project-standard confirmation wording.
    return Promise.resolve(confirm(MESSAGES.DELETE_SELECTED_RECORD_CONFIRM, MESSAGES.CONFIRM)).then((ok) => {
        if (!ok) return false;

        if (setBusy) setBusy(true);
        return axios.delete(
            `${window._env_.REACT_APP_APIS}/${data.TransManagementDp.DeleteTransManagementDp}?rowId=${rowId}`,
            { headers: { "Content-Type": "application/json", access_token: accessToken } },
        )
            .then((res) => {
                notify(res.data?.Message || MESSAGES.DELETE_SUCCESS, "success", 3000);
                return true;
            })
            .catch((err) => {
                if (!err?.[CONCURRENCY_HANDLED]) alert(getApiErrorMessage(err, MESSAGES.ERROR), MESSAGES.ERROR);
                return false;
            })
            .finally(() => {
                if (setBusy) setBusy(false);
            });
    });
}
